import Character from "@lss/common/src/shell/Character";
import { v1JoeBeachQuestions, v1VanessaDateConv, v6EmilyShoppingWindowDress } from "../../src/shell/PropertiesDeclarations";
import { TimageINT } from "../../src/store/slices/gameObjectSlice";
import { parseRequire } from "../../src/utils/parseImageUrl";
import { v8AnnChrisMcStateTypes } from "./empty";

interface McPropertiesINT {
    vanessaRelationship: number,
    annRelationship: number,
    jennyRelationship: number,
    emilyRelationship: number,
    alexRelationship: number,
    ivyRelationship: number;
    mean: number,

    annStatus: "natural" | "gf" | "hate";
    joeStatus: "natural" | "friend" | "enemy";
    chrisStatus: "natural" | "friend" | "enemy";
    vanessaStatus: "natural" | "friend" | "blackmail" | "blackmailAttempt";
    annLateGF: boolean;
    annLateHate: boolean;
    merryStatus?: "anal" | "blowjob" | "natural";
    hasJennysNumber?: boolean;



    alpha: number,
    liar: number,
    sawAlex: boolean,

    v1JoeConversation: v1JoeBeachQuestions[],
    v1Visited: "ann" | "joe" | undefined,
    metAnn: boolean,
    knowsAlexAndAnnFriends: boolean,
    metVanessa: boolean,
    v1VanessaDateConv: v1VanessaDateConv[],
    v1VanessasPhotosSeen: string[],
    v1MCSawVanessasBoobsAss?: "boobs" | "ass" | "both",
    vanessaRemovedPanties: boolean,
    agreeToChrisProposal?: boolean,
    v4SawAnnBJChrisInCar?: boolean,
    toldAnnBlackMail?: boolean,
    v3RudeToTheCustomer?: boolean,
    v6EmilyShoppingDress: v6EmilyShoppingWindowDress;
    v6EmilyPhotosSeen: string[],
    v7AnnChrisMovieStatus?: "went" | "refused" | "wasntInvited",

    v7WentWithJennyDate?: boolean;
    v7AnnCorruptedPhotosTaken: string[],
    v6SawEmilyNudePhoto?: boolean,
    alexEasterEgg2?: boolean,
    name: string,

    v7PreAuditionProgress: ("Invited-Chris" | "Begged-Chris" | "Chris-Blowjob" | "Begged" | "Blowjob" | "Alone")[];
    alexKnowsMC?: boolean,

    wantVanessaAsGF?: boolean,

    annBarCorruptionConv?: boolean;
    v7VanessaFucksMario?: boolean;
    gotKissedByEmily: boolean;
    v8ThreesomeWentFirst?: boolean;
    v8NightDeniedVanessaCompletely?: boolean;
    v8WentToThreesome?: boolean;

    v8VanessaVisitedAtNight?: boolean;
    v8AnnChrisHouseKissedAnn?: v8AnnChrisMcStateTypes[];
    v8gotLoveYouFromAnn?: boolean;
    v8AnnNightChrisParticipated?: boolean;
    v8AnnNightMCParticipated?: boolean;
    v8AnnNightMCCameEarly?: boolean;
    v9MCFuckedKim?: boolean;
    v9MCFuckedKimWithVanessa?: boolean;
    v9HadSexWithChrisBehindMCBack?: boolean;

}

const mcProperties: McPropertiesINT = {
    name: "ben",
    knowsAlexAndAnnFriends: false,
    vanessaRelationship: 0,
    alexRelationship: 0,
    annRelationship: 0,
    emilyRelationship: 0,
    liar: 0,
    alpha: 0,
    mean: 0,
    sawAlex: false,
    v1JoeConversation: [],
    metAnn: false,
    v1Visited: undefined,
    metVanessa: false,
    v1VanessaDateConv: [],
    v1VanessasPhotosSeen: [],
    vanessaRemovedPanties: false,
    annStatus: "natural",
    joeStatus: "friend",
    vanessaStatus: "natural",
    jennyRelationship: 0,
    v6EmilyShoppingDress: "purple",
    chrisStatus: "natural",
    v7AnnCorruptedPhotosTaken: [],
    v7PreAuditionProgress: [],
    v6EmilyPhotosSeen: [],
    ivyRelationship: 0,



    /**
     * this variable is to separate from annStatus 4 and 2-3
     * check annStatus GF when needed or this one for only status 4
     * 
     */
    annLateGF: false,
    //  Same as annLateGF
    annLateHate: false,
    gotKissedByEmily: false



};


const mc = new Character<McPropertiesINT>("Ben", mcProperties, "#176bef");

export {
    mc,
};

